import { SET_MAINTENANCE_SCHEDULE_READ, SET_MAINTENANCE_STATUS } from './maintenanceTypes';

export const setMaintenanceScheduleRead = () => dispatch => {
  return dispatch({
    type: SET_MAINTENANCE_SCHEDULE_READ,
  });
};

export const setMaintenanceStatus = () => dispatch => {
  return dispatch({
    type: SET_MAINTENANCE_STATUS,
    maintenance: compareMaintenanceDates(),
  });
};

const compareMaintenanceDates = () => {
  const maintenance = {
    startDate: window.MAINTENANCE_START_DATE,
    endDate: window.MAINTENANCE_END_DATE,
    isInProgress: false,
    isScheduled: false,
  };

  const now = new Date();
  const currentUTCTime = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), 0, 0);

  const startMaintenanceUTCTime = getUTCDateFromString(maintenance.startDate);
  const endMaintenanceUTCTime = getUTCDateFromString(maintenance.endDate);
  // IF the start and end maintenance date is between the current datetime, the Maintenance is set in progress
  if (currentUTCTime >= startMaintenanceUTCTime && currentUTCTime <= endMaintenanceUTCTime) {
    maintenance.isInProgress = true;
  } // If the end datetime in greather than today, It means there is no future maintenance scheduled
  else if (endMaintenanceUTCTime > currentUTCTime) {
    maintenance.isScheduled = true;
  }

  return maintenance;
};

const getUTCDateFromString = date => {
  return Date.UTC(
    parseInt(date.substr(0, 4)),
    parseInt(date.substr(8, 2)) - 1,
    parseInt(date.substr(5, 2)),
    parseInt(date.substr(11, 2)),
    parseInt(date.substr(14, 2)),
    0,
    0,
  );
};



// WEBPACK FOOTER //
// ./src/ui/features/Maintenance/state/maintenanceActions.js